import { Base64 } from 'js-base64';

function parseInviteInfo(encodedInviteInfo) {
    const decodedInviteInfo = Base64.decode(encodedInviteInfo);
    return JSON.parse(decodedInviteInfo);
}

export { parseInviteInfo };
